
import axios from 'axios';

export const getNotice = async () => {

    const { data } = await axios.get(`${process.env.REACT_APP_AWS_URL}/api/notices`);

    return data;

}